<template>
  <div class="GeneralSelect">
    <!-- 地图弹框切换 -->
    <span>{{ propertyData[propertyDataKey].lable }}</span>
    <el-select
      size="mini"
      @change="selectChange"
      v-model="currentValue"
      popper-class="GeneralSelect"
      placeholder="请选择"
    >
      <el-option v-for="item in select" :key="item.value" :label="item.label" :value="item.value">
      </el-option>
    </el-select>
  </div>
</template>
<script>
export default {
  name: 'GeneralSelect',
  props: {
    CurrentConfigration: Object,
    propertyData: Object,
    propertyDataKey: String,
  },
  data() {
    return {
      select: [],
      currentValue: '',
    };
  },
  created() {
    console.log(this.propertyData, 'propertyData afsdgvsdgsdgsd');
    console.log(this.propertyDataKey, 'propertyDataKey afsdgvsdgsdgsd');

    this.select = this.propertyData[this.propertyDataKey].select;
    this.currentValue = this.propertyData[this.propertyDataKey].value;
  },
  mounted() {},
  computed: {},
  methods: {
    selectChange(val) {
      this.$store.commit('update_PropertyData', {
        key: this.propertyDataKey,
        value: val,
      });
    },
  },
};
</script>
<style lang="scss" scoped>
.GeneralSelect {
  width: 100%;
  margin: 10px 0;
  box-sizing: border-box;
  display: flex;
  justify-content: space-between;
  align-items: center;
  .el-select {
    /* width: 192px; */

    :deep() input {
      color: #ffffff;
      background: #191b23;
      border-radius: 0;
      border-collapse: collapse;
      text-align: center;
      border: 1px solid rgb(90, 90, 90);

      &:hover {
        border: 1px solid #3179ff;
      }
      &:focus {
        border: 1px solid #3179ff;
      }
    }
  }
  span {
    box-sizing: border-box;
    color: $property-title-color;
    font-size: $property-title-size;
  }
  padding: 0 15px;
}
</style>
